// extracted by mini-css-extract-plugin
module.exports = {"title":"PrivacyPolicy_title__3IZD8","ol":"PrivacyPolicy_ol__22erP","li":"PrivacyPolicy_li__2Pzmu"};